// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'jfriou',
    name: 'whufih',
    phone: 'qmfrojh'
  },
  {
    contactKey: 'yutrvs',
    name: 'mgjyhgf',
    phone: 'gyftgfd'
  },
  {
    contactKey: 'gfyrtyrt',
    name: 'sdfwef',
    phone: 'sdgrthr'
  },
  {
    contactKey: 'rtgdfwerf',
    name: 'gntyjng',
    phone: 'fghjrtyrty'
  },
  {
    contactKey: 'fjhrth',
    name: 'fgnfhn',
    phone: 'dfgerg'
  },
  {
    contactKey: 'ktwsbpns',
    name: 'heacifnnqm',
    phone: 'wqfxflsq'
  },
  {
    contactKey: 'cmuyn',
    name: 'oqgbly',
    phone: 'pqvdlci'
  },
  {
    contactKey: 'nkmhlgfmtion',
    name: 'zupjrnlxpf',
    phone: 'kczhemogw'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'gherwsdfs',
  'tyyreds',
  'jtyheewr',
  'fsdjfwesd',
  'vvgxrfgoq',
  'ojjhi',
  'mxfsmrpumt'
]
export { contactsList, scoreFuncNameList }
